import { render } from "./NgramTextGen.vue?vue&type=template&id=2e34fa91"
import script from "./NgramTextGen.vue?vue&type=script&lang=js"
export * from "./NgramTextGen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__